module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "id": "cont",
      "title": "Contents"
    }
  }, [_c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('p', {
    staticClass: "h2f"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf0",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/9780253037756_Acknowledgments"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "note"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/9780253037756_Terms"
    }
  }, [_vm._v("Note on Terms")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "abb"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/9780253037756_Abbreviations"
    }
  }, [_vm._v("List of Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfa",
    attrs: {
      "id": "int"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/9780253037756_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253037756_Chapter_1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1")]), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Communities of Victims: Croatian Émigrés and Germans in the 1950s")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253037756_Chapter_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2")]), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("History on Trial: Migration, Political Violence, and Memories of World War II")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253037756_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3")]), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Second-Class Refugees: The West German–Yugoslav Migration Regime and the Asylum Problem")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253037756_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4")]), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Imagining Yugoslavs: From Communist Agents to Ambassadors of Peace")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253037756_Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5")]), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("The Return of the Nation: Bosnian Refugees in the New Germany")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocfa",
    attrs: {
      "id": "epi"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253037756_Epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfa",
    attrs: {
      "id": "app"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253037756_Appendix",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "bib"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253037756_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "ind"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253037756_Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")]), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40361d90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253037756_Contents.vue
// module id = 69
// module chunks = 0